import { useEffect, useState } from "react";
import { useConnectionState, useLoggedInUser } from "../mcptt/hooks";

/** Persistent 38px top strip. Mirrors design-handoff §5.1.
 *  Shows: time, MCPTT registration pill, app version, logged-in user. */
export function StatusBar() {
  const state = useConnectionState();
  const user  = useLoggedInUser();
  const [now, setNow] = useState(() => formatTime(new Date()));
  useEffect(() => {
    const id = setInterval(() => setNow(formatTime(new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="statusbar">
      <span className="sb-time">{now}</span>

      <span className={connectionPillClass(state)}>
        <span className="dot" />
        {connectionPillLabel(state)}
      </span>

      <span className="sb-spacer" />

      <span className="sb-pill muted" title="App release version (independent of wire VersionName)">
        v0.1.0
      </span>
      <span className="sb-pill muted" title={user?.id ?? ""}>
        {user
          ? <>
              <span style={{ color: "var(--steel-500)" }}>USER</span>
              &nbsp;{user.name || user.login || "—"}
            </>
          : "NO USER"}
      </span>
    </div>
  );
}

function connectionPillClass(state: string): string {
  if (state === "ready")          return "sb-pill";
  if (state === "reconnecting")   return "sb-pill warn";
  if (state === "configuring")    return "sb-pill warn";
  if (state === "logging-in")     return "sb-pill warn";
  if (state === "initializing")   return "sb-pill warn";
  if (state === "error")          return "sb-pill danger";
  return "sb-pill muted";
}

function connectionPillLabel(state: string): string {
  switch (state) {
    case "ready":         return "MCPTT ONLINE";
    case "configuring":   return "NEGOTIATING";
    case "logging-in":    return "AUTHENTICATING";
    case "initializing":  return "LOADING";
    case "reconnecting":  return "RECONNECTING";
    case "error":         return "ERROR";
    case "disconnected":  return "OFFLINE";
    default:              return state.toUpperCase();
  }
}

function formatTime(d: Date): string {
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}
